import { Grid } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../../Components/Button/WSButton";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { WSIcons } from "../../../commonFunctions/iIcons";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import http from "../../../commonFunctions/httpClient";

// ✅ CORRECT Interface matching your API structure
interface LabServiceItem {
  labService: {
    name: string;        // "Complete Blood Count (CBC)"
    testType: string;    // "test"
  };
}

interface RecentOrder {
  id: string;
  labId: string;
  collectionType: string;
  totalAmount: number;
  orderNumber: string;
  paymentMode: string;
  paymentStatus: string;
  status: string;
  createdAt: string;
  collectionFee: number;
  serviceFee: number;
  orderdate: string;
 labservice: LabServiceItem[];
  category?: string;  
}

export const RevenueRecentOrders: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();

  const [data, setData] = useState<RecentOrder[]>([]);
  const [labId, setLabId] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    updateMainHeader("Revenue & Payments");
  }, []);

  breadCrumbsStore.updateBreadCrumbs([
    { "Revenue & Payments": "revenue-payments/list" },
  ]);

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setLabId(userId || "");
  }, []);

const fetchDashboardData = useCallback(async (): Promise<void> => {
  if (!labId) {
    setLoading(false);
    return;
  }

  try {
    setLoading(true);
    setError("");
    const response: any = await http.get(`lab/LabDashBoard/${labId}`);
    const apiData = response.data || response || {};
    const recentOrders = apiData.recentOrders || [];
    
    // ✅ Transform EACH order to add category from testType
    const processedData: RecentOrder[] = recentOrders.map((order: any) => ({
      ...order,
      category: order.labservice?.[0]?.labService?.testType || "N/A"  // Gets "test"
    }));
    
    setData(processedData);
  } catch (err: any) {
    setError(err.message || "Failed to fetch recent orders");
    setData([]);
  } finally {
    setLoading(false);
  }
}, [labId]);
  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const handleAction = async (action: string, row: any) => {
    if (action === "View") {
      navigate(`/revenue-details/${row?.id}`);
    }
  };

  // ✅ FIXED: Gets labservice[0].labService.name
  const renderCategory = (row: RecentOrder) => {
    const firstLabService = row.labservice?.[0];
    return firstLabService?.labService?.name || "N/A";
  };

  const columns: IColumns[] = [
    {
      header: "Date",
      fieldName: "orderdate",
      type: "date",
    },
   {
  header: "Category",
  fieldName: "category",  // ✅ Now works - reads the transformed data
  type: "default",
},

    {
      header: "Order ID",
      fieldName: "orderNumber",
      type: "default",
    },
    {
      header: "Payment Mode",
      fieldName: "paymentMode",
      type: "default",
    },
    {
      header: "Amount",
      fieldName: "totalAmount",
      type: "default",
    },
    {
      header: "Status",
      fieldName: "paymentStatus",
      type: "status",
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["View"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  return (
    <>
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          {error ? (
            <div style={{ padding: 20, color: "red" }}>
              {error}. <button onClick={fetchDashboardData}>Retry</button>
            </div>
          ) : (
            <WSDataGridNew
              columns={columns}
              data={data}
              id="recentOrdersGrid"
              title="Recent Orders"
              exportCsv={true}
              addButton={{ label: "New Order", color: "secondary" }}
              searchBox={{ fieldName: "orderNumber" }}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});

export default RevenueRecentOrders;
